import { ActionTypes } from '../components/NavBar/ActionTypes'
import { updateNetwork } from '../store/network/NetworkActions'
import { Network, Networks } from './network'

export type NavBarLinkItem = {
  name: string
  link?: string
  redirect?: boolean
  dropdownOptions?: DropdownOption[]
  selected?: boolean
  dropdownIcon?: boolean
}

export type DropdownOption = {
  name: string
  link?: string
  selected?: boolean
  redirect?: boolean
  action?: (props: any) => ActionTypes
}

export const MAIN_NAV_BAR_LINKS: NavBarLinkItem[] = [
  {
    name: 'home',
    redirect: true,
    selected: true,
  },
  {
    name: 'relays',
    link: 'relays',
    redirect: true,
  },
  {
    name: 'connections',
    link: 'connections',
    redirect: true,
  },
  {
    name: 'tokens',
    link: 'tokens',
    redirect: true,
  },
]

const networkDispatchAction = (networkSelected: DropdownOption) => {
  return updateNetwork(networkSelected.name as Network)
}

export const NETWORK_SELECTION: NavBarLinkItem[] = [
  {
    name: 'network',
    redirect: false,
    dropdownOptions: Networks.map((network) => {
      return {
        name: network,
        selected: true,
        action: networkDispatchAction,
        redirect: false,
      }
    }),
    selected: false,
    dropdownIcon: true,
  },
]

export const networksToAPIMap = new Map<Network, string>([
  [Network.MainNet, process.env.REACT_APP_API_ENDPOINT || 'https://bridge-explorer-api.carbon.network'],
  [Network.TestNet, 'https://test-bridge-explorer-api.carbon.network'],
  [Network.DevNet, 'https://test-bridge-explorer-api.carbon.network'],
  [Network.Localhost, 'http://localhost:3000'],
])

export enum CarbonEndpoints {
  mainnet = 'https://api.carbon.network',
  testnet = 'https://test-api.carbon.network',
  // TODO: replace with 'https://dev-api.carbon.network' when bridge module is available
  devnet = 'http://203.118.10.75:20007',
  localhost = 'http://localhost:1317',
}

export const carbonNetworksToAPIMap = new Map<Network, string>([
  [Network.MainNet, CarbonEndpoints.mainnet],
  [Network.TestNet, CarbonEndpoints.testnet],
  [Network.DevNet, CarbonEndpoints.devnet],
  [Network.Localhost, CarbonEndpoints.localhost],
])
